const GetLicenceProfilePageUrl = (profileNo: string): string => {
  return `/licence-profile/${profileNo}`;
};

const GetLicenseeReturnPageUrl = (
  profileNo: string,
  returnId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/return/${returnId}`;
};

const GetIncidentPageUrl = (profileNo: string, incidentId: string): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/incident/${incidentId}`;
};

const GetIncidentUpdateRequestPageUrl = (
  profileNo: string,
  incidentUpdateRequestId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/incident-update-request/${incidentUpdateRequestId}`;
};

const GetComplaintDetailsPageUrl = (
  profileNo: string,
  complaintId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/complaint/${complaintId}`;
};

const GetSiteVisitDetailsPageUrl = (
  profileNo: string,
  siteVisitId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/sitevisit/${siteVisitId}`;
};

const GetSiteVisitFindingAndRecommendationsDetailsPageUrl = (
  profileNo: string,
  findingAndRecommendationId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/finding-and-recommendation/${findingAndRecommendationId}`;
};

const GetComplianceInvestigationDetailsPageUrl = (
  profileNo: string,
  complianceInvestigationId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/investigation/${complianceInvestigationId}`;
};

const GetActionOrInstructionDetailsPageUrl = (
  profileNo: string,
  actionOrInstructionId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/action-or-instruction/${actionOrInstructionId}`;
}; 

const GetEpaCorrespondenceDetailsPageUrl = (
  profileNo: string,
  epaCorrespondenceId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/epa-correspondence/${epaCorrespondenceId}`;
}; 

const GetThirdPartyCorrespondenceDetailsPageUrl = (
  profileNo: string,
  epaCorrespondenceId: string
): string => {
  return `${GetLicenceProfilePageUrl(profileNo)}/compliance/3rd-party-correspondence/${epaCorrespondenceId}`;
}; 

const GetComplianceRecordDetailsUrl = (
  complianceRecordId: string,
  complianceRecordType: string,
  profileNo: string
): string => {
  switch (complianceRecordType) {
    case "Site Visit":
      return GetSiteVisitDetailsPageUrl(profileNo, complianceRecordId);
    case "Compliance Investigation":
      return GetComplianceInvestigationDetailsPageUrl(profileNo, complianceRecordId);
    case "Incident":
      return `${GetLicenceProfilePageUrl(profileNo)}/compliance/incident/${complianceRecordId}`;
    case "Incident Update Request":
      return `${GetLicenceProfilePageUrl(profileNo)}/compliance/incident-update-request/${complianceRecordId}`;
    case "Complaint":
      return `${GetLicenceProfilePageUrl(profileNo)}/compliance/complaint/${complianceRecordId}`;
    case "Meeting":
      return `${GetLicenceProfilePageUrl(profileNo)}/compliance/meeting/${complianceRecordId}`;
    case "Non Compliance":
        return `${GetLicenceProfilePageUrl(profileNo)}/compliance/non-compliance/${complianceRecordId}`;
    case "EPA Initiated Correspondence":
      return GetEpaCorrespondenceDetailsPageUrl(profileNo, complianceRecordId);
    case "Third Party Correspondence":
      return GetThirdPartyCorrespondenceDetailsPageUrl(profileNo, complianceRecordId);
    default:
      return GetLicenseeReturnPageUrl(profileNo, complianceRecordId);
  }
};

export {
  GetLicenseeReturnPageUrl,
  GetComplianceRecordDetailsUrl,
  GetIncidentPageUrl,
  GetIncidentUpdateRequestPageUrl,
  GetLicenceProfilePageUrl,
  GetComplaintDetailsPageUrl,
  GetSiteVisitDetailsPageUrl,
  GetSiteVisitFindingAndRecommendationsDetailsPageUrl,
  GetComplianceInvestigationDetailsPageUrl,
  GetActionOrInstructionDetailsPageUrl,
  GetEpaCorrespondenceDetailsPageUrl,
  GetThirdPartyCorrespondenceDetailsPageUrl,
};

